import { pathscan_combined_lookup } from "./constants.js";

const getIdx = (i, j, width) => (i + j * width) * 4;

const imagePreProcessing = (imgd, alpha_threshold) => {
  const binary_imgd_arr = Array.from(Array(imgd.height + 2), () =>
    new Array(imgd.width + 2).fill(-1)
  );
  for (let j = 0; j < imgd.height; j++) {
    for (let i = 0; i < imgd.width; i++) {
      if (imgd.data[getIdx(i, j, imgd.width) + 3] > alpha_threshold) {
        binary_imgd_arr[j + 1][i + 1] = 1;
      } else {
        binary_imgd_arr[j + 1][i + 1] = 0;
      }
    }
  }
  return binary_imgd_arr;
};

const getScorePixelArr = (binary_imgd_arr) => {
  const arr_w = binary_imgd_arr[0].length;
  const arr_h = binary_imgd_arr.length;
  const score_pixel_arr = Array.from(Array(arr_h), () =>
    new Array(arr_w).fill(0)
  );
  for (let j = 1; j < arr_h; j++) {
    for (let i = 1; i < arr_w; i++) {
      score_pixel_arr[j][i] =
        (binary_imgd_arr[j - 1][i - 1] === 1 ? 1 : 0) +
        (binary_imgd_arr[j - 1][i] === 1 ? 2 : 0) +
        (binary_imgd_arr[j][i - 1] === 1 ? 8 : 0) +
        (binary_imgd_arr[j][i] === 1 ? 4 : 0);
    }
  }
  return score_pixel_arr;
};

const pathScan = (score_pixel_arr, path_omit) => {
  let paths = [],
    pacnt = 0,
    pcnt = 0,
    px = 0,
    py = 0,
    w = score_pixel_arr[0].length,
    h = score_pixel_arr.length,
    dir = 0,
    pathfinished = true,
    holepath = false,
    lookuprow;

  for (let j = 0; j < h; j++) {
    for (let i = 0; i < w; i++) {
      if (score_pixel_arr[j][i] === 4 || score_pixel_arr[j][i] === 11) {
        // Other values are not valid
        px = i;
        py = j;
        paths[pacnt] = {};
        paths[pacnt].points = [];
        paths[pacnt].boundingbox = [0, 0, w, h];
        paths[pacnt].holechildren = [];
        pathfinished = false;
        pcnt = 0;
        holepath = score_pixel_arr[j][i] === 11;
        dir = 1;

        // Path points loop
        while (!pathfinished) {
          // New path point
          paths[pacnt].points[pcnt] = {};
          paths[pacnt].points[pcnt].x = px - 1;
          paths[pacnt].points[pcnt].y = py - 1;
          paths[pacnt].points[pcnt].t = score_pixel_arr[py][px];
          // Next: look up the replacement, direction and coordinate changes = clear this cell, turn if required, walk forward
          lookuprow = pathscan_combined_lookup[score_pixel_arr[py][px]][dir];
          score_pixel_arr[py][px] = lookuprow[0];
          dir = lookuprow[1];
          px += lookuprow[2];
          py += lookuprow[3];
          // Close path
          if (
            px - 1 === paths[pacnt].points[0].x &&
            py - 1 === paths[pacnt].points[0].y
          ) {
            pathfinished = true;
            // Discarding paths shorter than pathomit
            if (paths[pacnt].points.length < path_omit) {
              paths.pop();
            } else {
              paths[pacnt].isholepath = holepath;
              // Finding the parent shape for this hole
              if (holepath) {
                paths[0].holechildren.push(pacnt);
              }
              pacnt++;
            }
          }
          pcnt++;
        }
      }
    }
  }
  return paths;
};

const testRightAngle = (path, idx1, idx2, idx3, idx4, idx5) => {
  return (
    (path.points[idx3].x === path.points[idx1].x &&
      path.points[idx3].x === path.points[idx2].x &&
      path.points[idx3].y === path.points[idx4].y &&
      path.points[idx3].y === path.points[idx5].y) ||
    (path.points[idx3].y === path.points[idx1].y &&
      path.points[idx3].y === path.points[idx2].y &&
      path.points[idx3].x === path.points[idx4].x &&
      path.points[idx3].x === path.points[idx5].x)
  );
};

const getDirection = (x1, y1, x2, y2) => {
  let val;
  if (x1 < x2) {
    if (y1 < y2) {
      val = 1;
    } // SouthEast
    else if (y1 > y2) {
      val = 7;
    } // NE
    else {
      val = 0;
    } // E
  } else if (x1 > x2) {
    if (y1 < y2) {
      val = 3;
    } // SW
    else if (y1 > y2) {
      val = 5;
    } // NW
    else {
      val = 4;
    } // W
  } else {
    if (y1 < y2) {
      val = 2;
    } // S
    else if (y1 > y2) {
      val = 6;
    } // N
    else {
      val = 8;
    } // center, this should not happen
  }
  return val;
};

const interNodes = (paths, options) => {
  var ins = [],
    palen = 0,
    nextidx = 0,
    nextidx2 = 0,
    previdx = 0,
    previdx2 = 0,
    pacnt,
    pcnt;

  // paths loop
  for (pacnt = 0; pacnt < paths.length; pacnt++) {
    ins[pacnt] = {};
    ins[pacnt].points = [];
    ins[pacnt].boundingbox = paths[pacnt].boundingbox;
    ins[pacnt].holechildren = paths[pacnt].holechildren;
    ins[pacnt].isholepath = paths[pacnt].isholepath;
    palen = paths[pacnt].points.length;

    // pathpoints loop
    for (pcnt = 0; pcnt < palen; pcnt++) {
      // next and previous point indexes
      nextidx = (pcnt + 1) % palen;
      nextidx2 = (pcnt + 2) % palen;
      previdx = (pcnt - 1 + palen) % palen;
      previdx2 = (pcnt - 2 + palen) % palen;

      // right angle enhance
      if (
        options.rightangleenhance &&
        testRightAngle(paths[pacnt], previdx2, previdx, pcnt, nextidx, nextidx2)
      ) {
        // Fix previous direction
        if (ins[pacnt].points.length > 0) {
          ins[pacnt].points[
            ins[pacnt].points.length - 1
          ].linesegment = getDirection(
            ins[pacnt].points[ins[pacnt].points.length - 1].x,
            ins[pacnt].points[ins[pacnt].points.length - 1].y,
            paths[pacnt].points[pcnt].x,
            paths[pacnt].points[pcnt].y
          );
        }

        // This corner point
        ins[pacnt].points.push({
          x: paths[pacnt].points[pcnt].x,
          y: paths[pacnt].points[pcnt].y,
          linesegment: getDirection(
            paths[pacnt].points[pcnt].x,
            paths[pacnt].points[pcnt].y,
            (paths[pacnt].points[pcnt].x + paths[pacnt].points[nextidx].x) / 2,
            (paths[pacnt].points[pcnt].y + paths[pacnt].points[nextidx].y) / 2
          ),
        });
      } // End of right angle enhance

      // interpolate between two path points
      ins[pacnt].points.push({
        x: (paths[pacnt].points[pcnt].x + paths[pacnt].points[nextidx].x) / 2,
        y: (paths[pacnt].points[pcnt].y + paths[pacnt].points[nextidx].y) / 2,
        linesegment: getDirection(
          (paths[pacnt].points[pcnt].x + paths[pacnt].points[nextidx].x) / 2,
          (paths[pacnt].points[pcnt].y + paths[pacnt].points[nextidx].y) / 2,
          (paths[pacnt].points[nextidx].x + paths[pacnt].points[nextidx2].x) /
            2,
          (paths[pacnt].points[nextidx].y + paths[pacnt].points[nextidx2].y) / 2
        ),
      });
    } // End of pathpoints loop
  } // End of paths loop
  return ins;
}; // End of internodes()

const fitseq = (path, ltres, qtres, seqstart, seqend) => {
  // return if invalid seqend
  if (seqend > path.points.length || seqend < 0) {
    return [];
  }
  // variables
  let errorpoint = seqstart,
    errorval = 0,
    curvepass = true,
    px,
    py,
    dist2;
  let tl = seqend - seqstart;
  if (tl < 0) {
    tl += path.points.length;
  }
  let vx = (path.points[seqend].x - path.points[seqstart].x) / tl,
    vy = (path.points[seqend].y - path.points[seqstart].y) / tl;

  // 5.2. Fit a straight line on the sequence
  var pcnt = (seqstart + 1) % path.points.length,
    pl;
  while (pcnt !== seqend) {
    pl = pcnt - seqstart;
    if (pl < 0) {
      pl += path.points.length;
    }
    px = path.points[seqstart].x + vx * pl;
    py = path.points[seqstart].y + vy * pl;
    dist2 =
      (path.points[pcnt].x - px) * (path.points[pcnt].x - px) +
      (path.points[pcnt].y - py) * (path.points[pcnt].y - py);
    if (dist2 > ltres) {
      curvepass = false;
    }
    if (dist2 > errorval) {
      errorpoint = pcnt;
      errorval = dist2;
    }
    pcnt = (pcnt + 1) % path.points.length;
  }
  // return straight line if fits
  if (curvepass) {
    return [
      {
        type: "L",
        x1: path.points[seqstart].x,
        y1: path.points[seqstart].y,
        x2: path.points[seqend].x,
        y2: path.points[seqend].y,
      },
    ];
  }

  // 5.3. If the straight line fails (distance error>ltres), find the point with the biggest error
  let fitpoint = errorpoint;
  curvepass = true;
  errorval = 0;

  // 5.4. Fit a quadratic spline through this point, measure errors on every point in the sequence
  // helpers and projecting to get control point
  let t = (fitpoint - seqstart) / tl,
    t1 = (1 - t) * (1 - t),
    t2 = 2 * (1 - t) * t,
    t3 = t * t;
  let cpx =
      (t1 * path.points[seqstart].x +
        t3 * path.points[seqend].x -
        path.points[fitpoint].x) /
      -t2,
    cpy =
      (t1 * path.points[seqstart].y +
        t3 * path.points[seqend].y -
        path.points[fitpoint].y) /
      -t2;

  // Check every point
  pcnt = seqstart + 1;
  while (pcnt !== seqend) {
    t = (pcnt - seqstart) / tl;
    t1 = (1 - t) * (1 - t);
    t2 = 2 * (1 - t) * t;
    t3 = t * t;
    px = t1 * path.points[seqstart].x + t2 * cpx + t3 * path.points[seqend].x;
    py = t1 * path.points[seqstart].y + t2 * cpy + t3 * path.points[seqend].y;

    dist2 =
      (path.points[pcnt].x - px) * (path.points[pcnt].x - px) +
      (path.points[pcnt].y - py) * (path.points[pcnt].y - py);

    if (dist2 > qtres) {
      curvepass = false;
    }
    if (dist2 > errorval) {
      errorpoint = pcnt;
      errorval = dist2;
    }
    pcnt = (pcnt + 1) % path.points.length;
  }
  // return spline if fits
  if (curvepass) {
    return [
      {
        type: "Q",
        x1: path.points[seqstart].x,
        y1: path.points[seqstart].y,
        x2: cpx,
        y2: cpy,
        x3: path.points[seqend].x,
        y3: path.points[seqend].y,
      },
    ];
  }
  // 5.5. If the spline fails (distance error>qtres), find the point with the biggest error
  let splitpoint = fitpoint; // Earlier: Math.floor((fitpoint + errorpoint)/2);

  // 5.6. Split sequence and recursively apply 5.2. - 5.6. to startpoint-splitpoint and splitpoint-endpoint sequences
  return fitseq(path, ltres, qtres, seqstart, splitpoint).concat(
    fitseq(path, ltres, qtres, splitpoint, seqend)
  );
};

const tracePath = (path, ltres, qtres) => {
  let pcnt = 0,
    segtype1,
    segtype2,
    seqend,
    smp = {};
  smp.segments = [];
  smp.boundingbox = path.boundingbox;
  smp.holechildren = path.holechildren;
  smp.isholepath = path.isholepath;

  while (pcnt < path.points.length) {
    // 5.1. Find sequences of points with only 2 segment types
    segtype1 = path.points[pcnt].linesegment;
    segtype2 = -1;
    seqend = pcnt + 1;
    while (
      (path.points[seqend].linesegment === segtype1 ||
        path.points[seqend].linesegment === segtype2 ||
        segtype2 === -1) &&
      seqend < path.points.length - 1
    ) {
      if (path.points[seqend].linesegment !== segtype1 && segtype2 === -1) {
        segtype2 = path.points[seqend].linesegment;
      }
      seqend++;
    }
    if (seqend === path.points.length - 1) {
      seqend = 0;
    }

    // 5.2. - 5.6. Split sequence and recursively apply 5.2. - 5.6. to startpoint-splitpoint and splitpoint-endpoint sequences
    smp.segments = smp.segments.concat(
      fitseq(path, ltres, qtres, pcnt, seqend)
    );

    // forward pcnt;
    if (seqend > 0) {
      pcnt = seqend;
    } else {
      pcnt = path.points.length;
    }
  } // End of pcnt loop

  return smp;
};

const batchtracepaths = (internodepaths, ltres, qtres) => {
  const btraced_paths = [];
  for (let k in internodepaths) {
    if (!internodepaths.hasOwnProperty(k)) {
      continue;
    }
    btraced_paths.push(tracePath(internodepaths[k], ltres, qtres));
  }
  return btraced_paths;
};

const imageDataToTraceData = (imgd, options) => {
  const trace_data = {
    layers: [],
    palette: options.palette,
    width: imgd.width,
    height: imgd.height,
  };

  // layeringstep -> pathscan -> internodes -> batchtracepaths
  const traced_layer = batchtracepaths(
    interNodes(
      pathScan(
        getScorePixelArr(imagePreProcessing(imgd, options.alpha_threshold)),
        options.pathomit
      ),
      options
    ),
    options.ltres,
    options.qtres
  );

  // adding traced layer
  trace_data.layers.push(traced_layer);
  return trace_data;
};

const roundToDec = (val, palaces) => {
  return +val.toFixed(palaces);
};

const svgPathStr = (tracedata, lnum, pathnum, options) => {
  let layer = tracedata.layers[lnum],
    smp = layer[pathnum],
    str = "",
    pcnt;

  // Line filter
  if (options.linefilter && smp.segments.length < 3) {
    return str;
  }

  // Starting path element
  str = '<path d="';

  // Creating non-hole path string
  if (options.roundcoords === -1) {
    str += "M " + smp.segments[0].x1 + " " + smp.segments[0].y1 + " ";
    for (pcnt = 0; pcnt < smp.segments.length; pcnt++) {
      str +=
        smp.segments[pcnt].type +
        " " +
        smp.segments[pcnt].x2 +
        " " +
        smp.segments[pcnt].y2 +
        " ";
      if (smp.segments[pcnt].hasOwnProperty("x3")) {
        str += smp.segments[pcnt].x3 + " " + smp.segments[pcnt].y3 + " ";
      }
    }
    str += "Z ";
  } else {
    str +=
      "M " +
      roundToDec(smp.segments[0].x1, options.roundcoords) +
      " " +
      roundToDec(smp.segments[0].y1, options.roundcoords) +
      " ";
    for (pcnt = 0; pcnt < smp.segments.length; pcnt++) {
      str +=
        smp.segments[pcnt].type +
        " " +
        roundToDec(smp.segments[pcnt].x2, options.roundcoords) +
        " " +
        roundToDec(smp.segments[pcnt].y2, options.roundcoords) +
        " ";
      if (smp.segments[pcnt].hasOwnProperty("x3")) {
        str +=
          roundToDec(smp.segments[pcnt].x3, options.roundcoords) +
          " " +
          roundToDec(smp.segments[pcnt].y3, options.roundcoords) +
          " ";
      }
    }
    str += "Z ";
  } // End of creating non-hole path string

  // Hole children
  for (let hcnt = 0; hcnt < smp.holechildren.length; hcnt++) {
    let hsmp = layer[smp.holechildren[hcnt]];
    // Creating hole path string
    if (options.roundcoords === -1) {
      if (hsmp.segments[hsmp.segments.length - 1].hasOwnProperty("x3")) {
        str +=
          "M " +
          hsmp.segments[hsmp.segments.length - 1].x3 +
          " " +
          hsmp.segments[hsmp.segments.length - 1].y3 +
          " ";
      } else {
        str +=
          "M " +
          hsmp.segments[hsmp.segments.length - 1].x2 +
          " " +
          hsmp.segments[hsmp.segments.length - 1].y2 +
          " ";
      }

      for (pcnt = hsmp.segments.length - 1; pcnt >= 0; pcnt--) {
        str += hsmp.segments[pcnt].type + " ";
        if (hsmp.segments[pcnt].hasOwnProperty("x3")) {
          str += hsmp.segments[pcnt].x2 + " " + hsmp.segments[pcnt].y2 + " ";
        }

        str += hsmp.segments[pcnt].x1 + " " + hsmp.segments[pcnt].y1 + " ";
      }
    } else {
      if (hsmp.segments[hsmp.segments.length - 1].hasOwnProperty("x3")) {
        str +=
          "M " +
          roundToDec(hsmp.segments[hsmp.segments.length - 1].x3) +
          " " +
          roundToDec(hsmp.segments[hsmp.segments.length - 1].y3) +
          " ";
      } else {
        str +=
          "M " +
          roundToDec(hsmp.segments[hsmp.segments.length - 1].x2) +
          " " +
          roundToDec(hsmp.segments[hsmp.segments.length - 1].y2) +
          " ";
      }

      for (pcnt = hsmp.segments.length - 1; pcnt >= 0; pcnt--) {
        str += hsmp.segments[pcnt].type + " ";
        if (hsmp.segments[pcnt].hasOwnProperty("x3")) {
          str +=
            roundToDec(hsmp.segments[pcnt].x2) +
            " " +
            roundToDec(hsmp.segments[pcnt].y2) +
            " ";
        }
        str +=
          roundToDec(hsmp.segments[pcnt].x1) +
          " " +
          roundToDec(hsmp.segments[pcnt].y1) +
          " ";
      }
    } // End of creating hole path string

    str += "Z "; // Close path
  } // End of holepath check

  // Closing path element
  str += '" />';

  // Rendering control points
  if (options.lcpr || options.qcpr) {
    for (pcnt = 0; pcnt < smp.segments.length; pcnt++) {
      if (smp.segments[pcnt].hasOwnProperty("x3") && options.qcpr) {
        str +=
          '<circle cx="' +
          smp.segments[pcnt].x2 +
          '" cy="' +
          smp.segments[pcnt].y2 +
          '" r="' +
          options.qcpr +
          '" fill="cyan" stroke-width="' +
          options.qcpr * 0.2 +
          '" stroke="black" />';
        str +=
          '<circle cx="' +
          smp.segments[pcnt].x3 +
          '" cy="' +
          smp.segments[pcnt].y3 +
          '" r="' +
          options.qcpr +
          '" fill="white" stroke-width="' +
          options.qcpr * 0.2 +
          '" stroke="black" />';
        str +=
          '<line x1="' +
          smp.segments[pcnt].x1 +
          '" y1="' +
          smp.segments[pcnt].y1 +
          '" x2="' +
          smp.segments[pcnt].x2 +
          '" y2="' +
          smp.segments[pcnt].y2 +
          '" stroke-width="' +
          options.qcpr * 0.2 +
          '" stroke="cyan" />';
        str +=
          '<line x1="' +
          smp.segments[pcnt].x2 +
          '" y1="' +
          smp.segments[pcnt].y2 +
          '" x2="' +
          smp.segments[pcnt].x3 +
          '" y2="' +
          smp.segments[pcnt].y3 +
          '" stroke-width="' +
          options.qcpr * 0.2 +
          '" stroke="cyan" />';
      }
      if (!smp.segments[pcnt].hasOwnProperty("x3") && options.lcpr) {
        str +=
          '<circle cx="' +
          smp.segments[pcnt].x2 +
          '" cy="' +
          smp.segments[pcnt].y2 +
          '" r="' +
          options.lcpr +
          '" fill="white" stroke-width="' +
          options.lcpr * 0.2 +
          '" stroke="black" />';
      }
    }

    // Hole children control points
    for (var hcnt = 0; hcnt < smp.holechildren.length; hcnt++) {
      var hsmp = layer[smp.holechildren[hcnt]];
      for (pcnt = 0; pcnt < hsmp.segments.length; pcnt++) {
        if (hsmp.segments[pcnt].hasOwnProperty("x3") && options.qcpr) {
          str +=
            '<circle cx="' +
            hsmp.segments[pcnt].x2 +
            '" cy="' +
            hsmp.segments[pcnt].y2 +
            '" r="' +
            options.qcpr +
            '" fill="cyan" stroke-width="' +
            options.qcpr * 0.2 +
            '" stroke="black" />';
          str +=
            '<circle cx="' +
            hsmp.segments[pcnt].x3 +
            '" cy="' +
            hsmp.segments[pcnt].y3 +
            '" r="' +
            options.qcpr +
            '" fill="white" stroke-width="' +
            options.qcpr * 0.2 +
            '" stroke="black" />';
          str +=
            '<line x1="' +
            hsmp.segments[pcnt].x1 +
            '" y1="' +
            hsmp.segments[pcnt].y1 +
            '" x2="' +
            hsmp.segments[pcnt].x2 +
            '" y2="' +
            hsmp.segments[pcnt].y2 +
            '" stroke-width="' +
            options.qcpr * 0.2 +
            '" stroke="cyan" />';
          str +=
            '<line x1="' +
            hsmp.segments[pcnt].x2 +
            '" y1="' +
            hsmp.segments[pcnt].y2 +
            '" x2="' +
            hsmp.segments[pcnt].x3 +
            '" y2="' +
            hsmp.segments[pcnt].y3 +
            '" stroke-width="' +
            options.qcpr * 0.2 +
            '" stroke="cyan" />';
        }
        if (!hsmp.segments[pcnt].hasOwnProperty("x3") && options.lcpr) {
          str +=
            '<circle cx="' +
            hsmp.segments[pcnt].x2 +
            '" cy="' +
            hsmp.segments[pcnt].y2 +
            '" r="' +
            options.lcpr +
            '" fill="white" stroke-width="' +
            options.lcpr * 0.2 +
            '" stroke="black" />';
        }
      }
    }
  } // End of Rendering control points

  return str;
};

const getSvgString = (tracedata, options) => {
  const w = tracedata.width,
    h = tracedata.height;
  // SVG start
  let svgstr =
    "<svg " +
    (options.viewbox
      ? 'viewBox="0 0 ' + w + " " + h + '" '
      : 'width="' + w + '" height="' + h + '" ') +
    'version="1.1" xmlns="http://www.w3.org/2000/svg" >';
  for (let lcnt = 0; lcnt < tracedata.layers.length; lcnt++) {
    for (let pcnt = 0; pcnt < tracedata.layers[lcnt].length; pcnt++) {
      // Adding SVG <path> string
      if (!tracedata.layers[lcnt][pcnt].isholepath) {
        svgstr += svgPathStr(tracedata, lcnt, pcnt, options);
      }
    }
  }
  svgstr += "</svg>";
  return svgstr;
};

export const tracingImageDataToSVG = (imgd, options) => {
  const image_trace_data = imageDataToTraceData(imgd, options);
  return getSvgString(image_trace_data, options);
};
